<template>
  <div>
    <!-- <a-affix :offset-top="100" id="content">

      <el-tree
        :data="data"
        :props="defaultProps"
        @node-click="handleNodeClick"

        :default-expand-all="true"
      ></el-tree>
    </a-affix> -->
    <el-backtop
      target=""
      style="width: 70px; height: 70px; font-size: 40px"
    ></el-backtop>
    <el-row class="tac" type="flex" justify="center">
      <el-col :span="16" id="doc">
        <div class="Section0" style="layout-grid: 15.6pt">
          <p
            class="MsoNormal"
            style="line-height: 21pt; mso-line-height-rule: exactly"
          >
            <b
              ><span
                style="
                  mso-spacerun: 'yes';
                  font-family: ����;
                  mso-ascii-font-family: 'Times New Roman';
                  mso-hansi-font-family: 'Times New Roman';
                  mso-bidi-font-family: 'Times New Roman';
                  font-weight: bold;
                  font-size: 16pt;
                  mso-font-kerning: 1pt;
                "
                ><font face="Times New Roman">PLantCTCIP</font></span
              ></b
            ><b
              ><span
                style="
                  mso-spacerun: 'yes';
                  font-family: 'Times New Roman';
                  mso-fareast-font-family: ����;
                  font-weight: bold;
                  font-size: 16pt;
                  mso-font-kerning: 1pt;
                "
                >&nbsp;Documentation</span
              ></b
            ><b
              ><span
                style="
                  mso-spacerun: 'yes';
                  font-family: 'Times New Roman';
                  mso-fareast-font-family: ����;
                  font-weight: bold;
                  font-size: 16pt;
                  mso-font-kerning: 1pt;
                "
                ><o:p></o:p></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            style="
              text-indent: 28pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Welcome to PLantCTCIP! This is the documentation for PLantCTCIP,
              a deep learning web service based on xx (python version and
              website technology stack).</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >&nbsp;</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >PLantCTCIP is free and open to all users. This website provides
              chromatin interaction prediction (proximal and proximal, proximal
              and distal types) based on four species: maize, rice, cotton, and
              wheat, sequence-based similarity search (BLAST), perform gene
              ontology (GO) analysis, visualize data results in the form of
              heatmaps or gradient plots (Visualization), analyze binding motifs
              of transcription factors (TF motifs), view and analyze genomic
              data using the Genome Browser (JBrowser), and genome-wide
              prediction.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="line-height: 21pt; mso-line-height-rule: exactly"
          >
            <b
              ><span
                style="
                  mso-spacerun: 'yes';
                  font-family: 'Times New Roman';
                  mso-fareast-font-family: ����;
                  font-weight: bold;
                  font-size: 16pt;
                  mso-font-kerning: 1pt;
                "
                >Overview</span
              ></b
            ><b
              ><span
                style="
                  mso-spacerun: 'yes';
                  font-family: 'Times New Roman';
                  mso-fareast-font-family: ����;
                  font-weight: bold;
                  font-size: 16pt;
                  mso-font-kerning: 1pt;
                "
                ><o:p></o:p></span
            ></b>
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l13 level1 lfo1;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#110;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              class="mulu"
              @click="clickTo('HomePage')"
              >Home Page</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l13 level1 lfo1;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#110;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              class="mulu"
              @click="clickTo('Tools')"
              ><font face="Times New Roman">Tools</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l10 level1 lfo2;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#216;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Prediction</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l4 level1 lfo3;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Species Select</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l4 level1 lfo3;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Model Select</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l4 level1 lfo3;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Target Interaction Pair Sequence Input (online or upload from
              disk)</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l4 level1 lfo3;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Submit Task</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >&nbsp;<font face="Times New Roman">or Reset</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l10 level1 lfo2;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#216;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">GO</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l14 level1 lfo4;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">T</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >arget </span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">G</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >ene </span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">L</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >ist</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >&nbsp;<font face="Times New Roman"
                >Input (online or u</font
              ></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >pload file</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">)</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l14 level1 lfo4;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Submit Task</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l10 level1 lfo2;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#216;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Blast</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              mso-list: l7 level1 lfo5;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Species Select</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l7 level1 lfo5;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">A </font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >FASTA </span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">S</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >equence </span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Input</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                color: rgb(0, 0, 0);
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >&nbsp;<font face="Times New Roman"
                >(online or upload file)</font
              ></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                color: rgb(0, 0, 0);
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l7 level1 lfo5;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Submit</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >&nbsp;<font face="Times New Roman">or Reset</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l13 level1 lfo1;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#110;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              class="mulu"
              @click="clickTo('Search')"
              ><font face="Times New Roman">Search</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l9 level1 lfo6;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Query Your Job</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l9 level1 lfo6;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Job Queue</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l9 level1 lfo6;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Detailed Results Display of Your Job</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l13 level1 lfo1;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#110;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              class="mulu"
              @click="clickTo('Results')"
              ><font face="Times New Roman">Results</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l10 level1 lfo2;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#216;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Predictions</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              mso-list: l6 level1 lfo7;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Species Select</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l10 level1 lfo2;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#216;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Statistics</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l10 level1 lfo2;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#216;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Grad</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >i</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">ent Distract</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              mso-list: l0 level1 lfo8;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Species Select</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l0 level1 lfo8;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Statistics</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l10 level1 lfo2;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#216;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Heatmap</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l11 level1 lfo9;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Species Select</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l11 level1 lfo9;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Statistics</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l10 level1 lfo2;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#216;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Validation</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l2 level1 lfo10;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Species Select</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l2 level1 lfo10;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Statistics</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l2 level1 lfo10;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Motifs Enrichment</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l2 level1 lfo10;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Species Select</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 66pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l2 level1 lfo10;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Statistics</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l13 level1 lfo1;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#110;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Browser</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l13 level1 lfo1;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#110;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              class="mulu"
              @click="clickTo('Tutorial')"
              ><font face="Times New Roman">Tutorial</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 44pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l3 level1 lfo11;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#108;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Service Guide</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l13 level1 lfo1;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: Wingdings;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >&#110;</span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              class="mulu"
              @click="clickTo('Resources')"
              ><font face="Times New Roman">Resources</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              mso-list: l5 level1 lfo12;
            "
          >
            <![if !supportLists]><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ref="HomePage"
              >1、Home Page</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="MsoNormal">
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >The appearance of the home page is shown in the figure
              below.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="MsoNormal">
            <img
            class="imgcenter"
              width="554"
              height="418"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation1396.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: Calibri;
                mso-fareast-font-family: ����;
                mso-bidi-font-family: 'Times New Roman';
                font-size: 10.5pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            style="
              text-indent: 28pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Here you can see an introduction to PLantCTCIP, you can make a
              selection of three tools for Prediction, BLAST, and GO Analytics,
              you can make a selection of six tools, and you can also go
              straight to Tools, Search, Results, Browser, Tutorial via the top
              bar.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              text-indent: 28pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >You can click the home button to return to the home page.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              mso-list: l5 level1 lfo12;
            "
          >
            <![if !supportLists]><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ref="Tools"
              ><font face="Times New Roman">2、Tools</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l8 level1 lfo13;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore">1.<span>&nbsp;</span></span></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">Prediction</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >From the Home screen, you can access the Prediction screen by
              selecting the Prediction tool from the selection top bar Tools.
              You can then choose any of the four species - corn, rice, cotton,
              and wheat to predict the target task (as shown below).</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 0pt; line-height: 12pt">
            <img
            class="imgcenter"
              width="554"
              height="297"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation1979.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >Then you will jump to the interface of model selection, mode
              selection for data input and data input format requirement, and
              you will perform the corresponding operations. Note: For target
              interaction pair sequence input, you can use online direct input
              or upload from disk; we have provided the official data example
              format and notes, you can get the related information through
              Note; when submitting the task, you must provide a reliable email
              address to receive future alerts on the task running status; at
              the same time, in order to prevent robotic manipulation, you need
              to enter the dynamic information.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >The operation sequence is as follows (as shown in the following
              figure).</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 0pt; line-height: 12pt">
            <img
            class="imgcenter"
              width="554"
              height="285"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation2664.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p class="39" style="margin-left: 66.05pt; line-height: 12pt">
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                color: rgb(255, 0, 0);
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l8 level1 lfo13;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore">2.<span>&nbsp;</span></span></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">GWI Prediction</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >Based on the previous step, GWI Prediction was selected at
              operation order 2 for genome-wide prediction, and the procedure
              was as follows:</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 0pt; line-height: 12pt">
            <img
            class="imgcenter"
              width="554"
              height="266"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation2821.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l8 level1 lfo13;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore">3.<span>&nbsp;</span></span></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">GO</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >In the Home screen, you can access the GO Analyzer screen by
              selecting the GO tool from the top bar, Tools.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 66.05pt; text-align: center; line-height: 12pt"
          >
            <img
            class="imgcenter"
              width="290"
              height="210"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation2934.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p class="39" style="margin-left: 0pt; line-height: 12pt">
            <img
            class="imgcenter"
              width="554"
              height="225"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation2936.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p class="39" style="margin-left: 66.05pt; line-height: 12pt">
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l8 level1 lfo13;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore">4.<span>&nbsp;</span></span></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">BLAST</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >In the Home screen, you can select the Blast tool from the
              selection of Tools in the top bar to access the Blast Analyzer
              screen.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 0pt; text-align: center; line-height: 12pt"
          >
            <img
            class="imgcenter"
              width="287"
              height="206"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation3075.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p class="39" style="margin-left: 66pt; line-height: 12pt">
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >The BLAST interface provides species selection buttons, two forms
              of data entry, an official data example format, then enter your
              email to receive the mission run status, and finally click Submit
              or Reset to complete a process operation. The sequence of
              operations is shown below:</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 66pt; line-height: 12pt">
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p class="39" style="margin-left: 0pt; line-height: 12pt">
            <img
            class="imgcenter"
              width="554"
              height="279"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation3360.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              mso-list: l5 level1 lfo12;
            "
          >
            <![if !supportLists]><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ref="Search"
              ><font face="Times New Roman">3、Search</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l12 level1 lfo14;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore">1.<span>&nbsp;</span></span></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >Query Your Job</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >After submitting your task, you will receive a unique job ID.
              After receiving an email notifying you that the submitted task has
              completed running, you can query your task through the job ID in
              the Search interface and collect the results.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 0pt; line-height: 12pt">
            <img
            class="imgcenter"
              width="554"
              height="92"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation3624.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l12 level1 lfo14;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore">2.<span>&nbsp;</span></span></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >Job Queue</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >After entering the job ID query, you can view the running status
              of your task (with a check indicating successful operation and a
              cross indicating failed operation). Clicking on the View results
              button will display the predicted results and statistical
              information of </span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">PLantCTCIP </font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >in detail (as shown in the following figure).</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 0pt; line-height: 12pt">
            <img
            class="imgcenter"
              width="554"
              height="219"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation3961.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              line-height: 21pt;
              mso-line-height-rule: exactly;
              mso-list: l12 level1 lfo14;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore">3.<span>&nbsp;</span></span></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >Detailed Results Display of Your Job</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 0pt; line-height: 12pt">
            <img
            class="imgcenter"
              width="554"
              height="245"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation4000.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p class="39" style="margin-left: 39.95pt; line-height: 12pt">
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              mso-list: l5 level1 lfo12;
            "
          >
            <![if !supportLists]><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ref="Result"
              >4、Result</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              mso-list: l1 level1 lfo15;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >1.<span>&nbsp;</span></span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Prediction</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >In the Home screen, you can select Prediction from the top bar
              Results to enter the Prediction results display screen.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 40pt; text-align: center"
          >
            <img
            class="imgcenter"
              width="186"
              height="243"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation4140.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >Once you enter this screen, make your species selection, after
              which you can see the results of your test, including the
              interaction prediction results, detailed information about the
              interaction, and the gradient and heatmap plotted against the
              interaction pair. The page is displayed as follows:</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 0pt; text-align: center"
          >
            <img
            class="imgcenter"
              width="404"
              height="931"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation4440.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 0pt; text-align: center"
          >
            <img
            class="imgcenter"
              width="554"
              height="219"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation4442.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 0pt; text-align: center"
          >
            <img
            class="imgcenter"
              width="541"
              height="317"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation4444.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              mso-list: l1 level1 lfo15;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >2.<span>&nbsp;</span></span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Gradent Distract</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >In the Home screen, you can select Gradent Distract from the
              selection top bar Results to enter the Gradent Distract results
              display screen.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 40pt; text-align: center"
          >
            <img
            class="imgcenter"
              width="187"
              height="248"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation4604.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >Once you enter this screen and make a species selection, you can
              see the results of Gradent Distract for each species. The
              procedure is as follows:</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 0pt">
            <img
            class="imgcenter"
              width="554"
              height="281"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation4754.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              mso-list: l1 level1 lfo15;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >3.<span>&nbsp;</span></span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Heat Map</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >In the Home screen, you can select Heat Map from the top bar
              Results to enter the Heat Map results display screen.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 40pt; text-align: center"
          >
            <img
            class="imgcenter"
              width="186"
              height="244"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation4880.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >Once you enter this screen and make a species selection, you can
              see the results of the Heat Map for each species. The procedure is
              as follows:</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 0pt">
            <img
            class="imgcenter"
              width="554"
              height="123"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation5026.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 0pt; text-align: center"
          >
            <img
            class="imgcenter"
              width="554"
              height="287"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation5028.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p class="39" style="margin-left: 0pt">
            <img
            class="imgcenter"
              width="554"
              height="153"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation5030.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                color: rgb(255, 0, 0);
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              mso-list: l1 level1 lfo15;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >4.<span>&nbsp;</span></span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Validation</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >In the Home screen, you can select Validation from the top bar
              Results to enter the Validation results display screen.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 40pt; text-align: center"
          >
            <img
            class="imgcenter"
              width="188"
              height="244"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation5162.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >Once you enter this screen and make a species selection, you can
              see the results of the Validation for each species. The procedure
              is as follows:</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 0pt">
            <img
            class="imgcenter"
              width="554"
              height="231"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation5310.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 0pt;
              mso-list: l1 level1 lfo15;
            "
          >
            <![if !supportLists]><span
              style="
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><span style="mso-list: Ignore"
                >5.<span>&nbsp;</span></span
              ></span
            ><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Motifs Enrichment</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >In the Home screen, you can select Motifs Enrichment from the
              selection top bar Results to enter the Motifs Enrichment results
              display screen.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 40pt; text-align: center"
          >
            <img
            class="imgcenter"
              width="188"
              height="242"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation5473.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 0pt;
              text-indent: 24pt;
              mso-char-indent-count: 2;
              line-height: 21pt;
              mso-line-height-rule: exactly;
            "
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              >After entering this interface, the first step is to select the
              species, the second step is to select the data again if the
              species contains more than one set of data, and the last step is
              to display the corresponding Motifs enrichment results. The
              procedure is as follows:</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 12pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 0pt; text-align: center"
          >
            <img
            class="imgcenter"
              width="554"
              height="237"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation5748.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 40pt; text-align: center"
          >
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              mso-list: l5 level1 lfo12;
            "
          >
            <![if !supportLists]><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ref="Browser"
              >5、Browser</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 22pt">
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                color: rgb(255, 0, 0);
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="����">暂无</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                color: rgb(255, 0, 0);
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 22.1pt;
              text-indent: -22pt;
              mso-list: l5 level1 lfo12;
            "
          >
            <![if !supportLists]><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ref="Tutorial"
              >6、Tutorial</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 22.1pt">
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >Here is an online guide for users to use PlantCTCIP.</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            style="
              margin-left: 22pt;
              text-indent: -22pt;
              mso-list: l5 level1 lfo12;
            "
          >
            <![if !supportLists]><![endif]><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ref="Resources"
              >7、Resources</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p class="39" style="margin-left: 22pt">
            <span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >At the bottom of each interface, we provide link addresses for
              commonly used resources, which you can access and download
              according to your actual needs (as shown in the foll</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: ����;
                mso-ascii-font-family: 'Times New Roman';
                mso-hansi-font-family: 'Times New Roman';
                mso-bidi-font-family: 'Times New Roman';
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><font face="Times New Roman">o</font></span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              >wing figure).</span
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="39"
            align="center"
            style="margin-left: 0pt; text-align: center"
          >
            <img
            class="imgcenter"
              width="554"
              height="274"
              src="PLantCTCIPDocumentation.files/PLantCTCIPDocumentation6025.png"
            /><span
              style="
                mso-spacerun: 'yes';
                font-family: 'Times New Roman';
                mso-fareast-font-family: ����;
                font-size: 14pt;
                mso-font-kerning: 1pt;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
        </div>

      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [
        {
          label: "导航1",
          ref: "top1",
          children: [
            {
              label: "选项1",
            },
            {
              label: "选项2",
            },
            {
              label: "选项3",
            },
            {
              label: "选项4",
            },
          ],
        },
        {
          label: "导航2",
          ref: "top2",
        },
        {
          label: "导航3",
          ref: "top3",
        },
        {
          label: "导航4",
          ref: "top4",
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  methods: {
    handleNodeClick(data) {
      // console.log(data);
      // console.log(data.label);

      this.$refs[data.ref].scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "center", // start 上边框  center 中间  end 底部边框 与视窗顶部平齐
      });
    },

    clickTo(id) {
      this.$refs[id].scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "center", // start 上边框  center 中间  end 底部边框 与视窗顶部平齐
      });
    },
  },
};
</script>

<style scoped>
#content {
  position: absolute;
  /* height: 600px; */
  width: 300px;
  z-index: 999;
}
#doc i {
  font-weight: bold;
  font-size: 30px;
}

#doc p {
  font-size: 20px;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
}

.el-tree-node__label {
  width: auto;
  margin-top: 12px;
  margin-left: 50px;
  /* float: right; */
  font-family: “Trebuchet MS”, Arial, Helvetica, sans-serif;
  font-size: 18px;
  /* color: #999999; */
  line-height: 50px;
  letter-spacing: 1px;
}

.el-tree-node__content {
  height: 35px;
}

.el-tree-node__expand-icon {
  color: #22cab3;
  font-size: 20px;
}

.el-tree-node:focus > .el-tree-node__content {
  /* background-color: #66b1ff87 !important; */
  color: #22cab3;
}

.mulu {
  cursor: pointer;
  color: #4ea1db;
}
.imgcenter{
  display: block;
  margin: 0 auto;
}
</style>



